// const getViewComponent = process.env.NODE_ENV === 'production' ? (path) => (resolve) => require(['@/views' + path + '.vue'], resolve) : (path) => require('@/views' + path + '.vue')

const getViewComponent = (path) => (resolve) => require(['@/views' + path + '.vue'], resolve)

export default [{
        path: '/',
        component: getViewComponent('/common/index'),
        children: [

        ],
        meta: { title: '拓普基因' }
    },

    { path: '/login', component: getViewComponent('/common/login'), meta: { title: '登录-拓普基因网站管理后台' } }
]



// WEBPACK FOOTER //
// ./src/routes/routes.js